import { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import Banner from '../../components/Banner';
import usePlatform from '../../hooks/usePlatform';
import { BANNER_TYPE, linkIcons } from '../../components/constants';
import { getBannerOperationExtraAttr } from '../../scripts/utils';
import { getAICarousel } from './services'
import './ppt.scss';

const buttonThemes = {
  theme: '#2A2B2E'
};

export default function () {
  const { isPc } = usePlatform() || {};
  const [list, setList] = useState<any[]>([]);

  useEffect(() => {
    getAICarousel().then((res: any) => {
      setList(isEmpty(res) ? [] : res)
    })
  }, [])

  return (
    <>
      {!isEmpty(list) && <Banner
        covered={true}
        useArrow
        key='ai-ppt'
        size="small"
        type={BANNER_TYPE.CAROUSEL}
        height={isPc ? 530 : 320}
        paddingTop={isPc ? 340 : 0}
        className="ai-ppt-banner"
        config={list.map(data => {
          return {
            src: data.pcResourceUrl,
            mobileSrc: data.mobileResourceUrl,
            title: '',
            legend: '',
            operation: [
              {
                ...buttonThemes,
                // icon: 'label',
                text: data?.jumpBO?.buttonTitle || '立即咨询',
                icon: linkIcons[data?.jumpBO?.jumpContentType],
                extraAttr: getBannerOperationExtraAttr(data)
              }
            ]
          };
        })}
      />}
    </>
  );
}

